import classnames from 'classnames'
import { useChartLayoutGlobalModelAsync } from 'finviz-charts/app/utils/useChartLayoutGlobalModelAsync'

import { SpecificChartFunctionality } from '../../../main/constants'
import { StatsQuery } from '../../stats/types'
import { useChartTimeframePathWatch } from '../use-chart-timeframe-path-watch'

const originalElement = document.querySelector<HTMLAnchorElement>('.js-stock-detail-link a')

export default function StockDetailLink() {
  const currentTimeframePath = useChartTimeframePathWatch()
  const { chartLayoutModel } = useChartLayoutGlobalModelAsync()
  const isQuotePage = chartLayoutModel?.specificChartFunctionality === SpecificChartFunctionality.quotePage
  const isQuoteOrQuoteFinancials =
    isQuotePage || chartLayoutModel?.specificChartFunctionality === SpecificChartFunctionality.quoteFinancials

  const label = (
    <>
      <span className="xl:hidden">Chart</span>
      <span className="hidden xl:inline">Stock Detail</span>
    </>
  )

  if (!currentTimeframePath || !isQuoteOrQuoteFinancials)
    return (
      <a href={originalElement?.href} className={originalElement?.className}>
        {label}
      </a>
    )

  const newURL = new URL(currentTimeframePath, window.location.origin)
  newURL.searchParams.delete(StatsQuery.ChartType)

  return (
    <a href={`${newURL.pathname}${newURL.search}`} className={classnames('tab-link', { 'font-semibold': isQuotePage })}>
      {label}
    </a>
  )
}
